<template>
  <scroller lock-y :scrollbar-x="false">
    <div
      class="tab-box hasPadding"
      :style="{ width: list.length * 2.9 + 'rem' }"
    >
      <div
        :class="['tab-div', `tab-color-${colorClass[index]}`]"
        v-for="(item, index) in list"
        :key="index"
        @click="handleTabClick(item)"
      >
        <span class="tab-seat" ref="tab-seats">#{{ item.categoryName }}</span>
        <div class="tab-item">#{{ item.categoryName }}</div>
      </div>
    </div>
  </scroller>
  <!-- <div class="tab-box">
        <div class="tab-scroll hasPadding" :style="{width:list.length * 3 + 'rem'}">
            <div :style="{marginRight:index < list.length -1 ? '.4rem' : '0'}" class="tab-div" v-for="(item,index) in list" :key="index" @click="handleTabClick(item)">
                <div class="tab-item">
                    #{{item.categoryName}}
                </div>
            </div>
        </div>

    </div> -->

  <!-- <div style="height:100px">
      <scroll ref="scroll" :scrollX="true" :scrollY="false">
        <ul class="uul">
          <li v-for="item in 50">{{item}}</li>
        </ul>
      </scroll>
    </div> -->
</template>

<script>
import { Scroller } from 'vux';
export default {
  props: {
    list: {
      type: Array,
      defult() {
        return null;
      }
    }
  },
  data() {
    return {
      colorClass: [],
      scrollBoxWidth: '100%'
    };
  },
  components: {
    Scroller
  },
  methods: {
    handleTabClick(item) {
      this.$router.push({
        name: 'blTopic',
        params: {
          id: item.categoryId || item.id
        },
        query: {
          categoryName: item.categoryName
        }
      });
    }
    // setColor(index, leftColor, rightColor) {
    //     this.colors[index] = {
    //         left: leftColor,
    //         right: rightColor,
    //     }
    // },
    // setColorStyle(index){
    //
    //   return `linear-gradient(left, ${this.colors[index].left}, ${this.colors[index].right});`
    // }
  },
  watch: {
    list: {
      deep: true,
      immediate: true,
      handler(v) {
        this.colorClass = [];
        v.forEach((item, index) => {
          let count = 0;
          for (let name of item.categoryName) {
            count += name.charCodeAt(0);
          }
          let tagColor = count % 7;
          this.colorClass.push(tagColor);

          // switch (tagColor) {
          //     case 0:
          //
          //         this.setColor(index, '#2EEDFF', '#027CFA')
          //
          //         break;
          //     case 1:
          //         this.setColor(index, '#EBA3FF', '#704AFB')
          //         break;
          //     case 2:
          //
          //         this.setColor(index, '#FFAAAA', '#FF300A')
          //         break;
          //     case 3:
          //         this.setColor(index, '#B4ED50', '#429321')
          //         break;
          //     case 4:
          //         this.setColor(index, '#4FE8FF', '#7945FF')
          //         break;
          //     case 5:
          //         this.setColor(index, '#FFF592', '#FF6D03')
          //         break;
          //     default:
          //         this.setColor(index, '#93E9FF', '#013BFF')
          //         break;
          // }
        });
        this.$nextTick(_ => {
          //   console.log(this.$refs['tab-seats'][0].clientWidth)
          let width = 0;
          this.$refs['tab-seats'].forEach((item, index) => {
            width += item.clientWidth + 30;
          });
        });
        // this.scrollBoxWidth = '123px'
        // console.log(this.colors)
      }
    }
  }
};
</script>

<style lang="less">
.tab-box {
  width: 100%;

  height: 0.9333rem /* 70/75 */;
  display: flex;
  flex-wrap: nowrap;
}

.tab-div {
  box-sizing: initial;
  margin-left: 0.4rem;
  min-width: 2.4rem /* 180/75 */;
  height: 0.9067rem /* 68/75 */;
  // padding: 0 .4933rem/* 37/75 */
  // ;
  border: 1px /* 2/75 */ solid transparent;
  // background-image: linear-gradient(left, #FF6D03, #FFF592);
  border-radius: 0.0533rem 0.55rem 0.0533rem 0.55rem;

  position: relative;
  // padding: 0 .2rem;
  .tab-seat {
    font-size: 0.4rem;
    line-height: 0.9067rem;
    visibility: hidden;
    display: block;
    padding: 0 0.2rem;
  }
  .tab-item {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    width: 100%;
    height: 98%;
    background: #fff;
    border-radius: 0.0533rem 0.55rem 0.0533rem 0.55rem;
    border: 1px solid transparent;
    transform: scale(0.98);
    font-size: 0.4rem /* 30/75 */;
    color: #3699ff;
    line-height: 0.9067rem;
    text-align: center;
  }
}

.tab-color-0 {
  background-image: linear-gradient(right, #2eedff, #027cfa);
}
.tab-color-1 {
  background-image: linear-gradient(right, #eba3ff, #704afb);
}
.tab-color-2 {
  background-image: linear-gradient(right, #ffaaaa, #ff300a);
}
.tab-color-3 {
  background-image: linear-gradient(right, #b4ed50, #429321);
}
.tab-color-4 {
  background-image: linear-gradient(right, #4fe8ff, #7945ff);
}
.tab-color-5 {
  background-image: linear-gradient(right, #fff592, #ff6d03);
}
.tab-color-6 {
  background-image: linear-gradient(right, #93e9ff, #013bff);
}

.tab-div:first-child {
  margin-left: 0;
}

// .tab-div {
//     height: .9067rem /* 68/75 */;
//     position: relative;
//     min-width: 10rem;
// }
//
// .box1-item {
//     width: 2.4rem /* 180/75 */;
//     height: .9067rem /* 68/75 */;
//     background-color: #ccc;
//     display: inline-block;
//         float: left;
//     margin-left: 15px;
//
//     text-align: center;
//     line-height: 100px;
// }
//
// .box1-item:first-child {
//     margin-left: 0;
// }
</style>
